<div class="card spacing--margin-all">
  <agr-summary-card
    title="{{ 'settings-navigation.observationsetting' | translate }}"
    [canExpand]="false"
  >
    <div class="spacing--padding-all">
      <h6 class="text--h6">{{ 'observations-setting.description' | translate }}</h6>
      <mat-slide-toggle
        [hideIcon]="true"
        class="spacing--margin-bottom spacing--padding-vertical"
        color="primary"
        data-test="setting__observation-switch"
        [(ngModel)]="observationSwitchSetting"
        (change)="switchObservationSetting($event)"
      >
        {{ 'observations-setting.switch' | translate }}
      </mat-slide-toggle>
    </div>
  </agr-summary-card>
</div>

<div class="card spacing--margin-all">
  <agr-summary-card title="{{ 'unitOfMeasure-setting.title' | translate }}" [canExpand]="false">
    <div class="spacing--padding-all">
      <h6 class="text--h6">{{ 'unitOfMeasure-setting.feedIntakeUnit' | translate }}</h6>
      <div class="radio-group-wrapper">
        <mat-radio-group
          class="radio-group"
          [ngModel]="(unitOfMeasureSettings$ | async)?.feedIntakeUnit"
          (ngModelChange)="changeUnitOfMeasureSettings($event, 'feedIntakeUnit')"
        >
          <mat-radio-button
            *ngFor="let feedIntakeUnit of feedIntakeUnits"
            [value]="feedIntakeUnit"
            color="primary"
            [attr.data-test]="'settings__unitOfMeasure-' + feedIntakeUnit"
          >
            {{ 'unitOfMeasure-setting.' + feedIntakeUnit | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="wrapper--spacing-vertical">
        <h6 class="text--h6">{{ 'unitOfMeasure-setting.waterIntakeUnit' | translate }}</h6>
        <div class="radio-group-wrapper">
          <mat-radio-group
            class="radio-group"
            [ngModel]="(unitOfMeasureSettings$ | async)?.waterIntakeUnit"
            (ngModelChange)="changeUnitOfMeasureSettings($event, 'waterIntakeUnit')"
          >
            <mat-radio-button
              *ngFor="let waterIntakeUnit of waterIntakeUnits"
              [value]="waterIntakeUnit"
              color="primary"
              [attr.data-test]="'settings__unitOfMeasure-' + waterIntakeUnit"
            >
              {{ 'unitOfMeasure-setting.' + waterIntakeUnit | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <span class="text--small text--gray">{{ 'unitOfMeasure-setting.warning' | translate }}</span>
    </div>
  </agr-summary-card>
</div>

<div class="card spacing--margin-all">
  <agr-summary-card title="{{ 'settings-navigation.rvssetting' | translate }}" [canExpand]="false">
    <div class="spacing--padding-all">
      <h6 class="text--h6">{{ 'rvs-setting.temperatureInside-option.label' | translate }}</h6>
      <div class="radio-group-wrapper">
        <mat-radio-group
          class="radio-group"
          [ngModel]="(rvsSettings$ | async)?.temperatureUnit"
          (ngModelChange)="changeSystem($event, 'temperatureUnit')"
        >
          <mat-radio-button
            *ngFor="let temperatureUnit of temperatureUnits"
            [value]="temperatureUnit"
            color="primary"
            [attr.data-test]="'settings__temperatureInside-' + temperatureUnit"
          >
            {{ 'rvs-setting.temperatureInside-option.' + temperatureUnit | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="wrapper--spacing-vertical">
        <h6 class="text--h6">{{ 'rvs-setting.feedIntake-option.label' | translate }}</h6>
        <div class="radio-group-wrapper">
          <mat-radio-group
            class="radio-group"
            [ngModel]="(rvsSettings$ | async)?.feedUnit"
            (ngModelChange)="changeSystem($event, 'feedUnit')"
          >
            <mat-radio-button
              *ngFor="let feedUnit of feedUnits"
              color="primary"
              [value]="feedUnit"
              [attr.data-test]="'settings__feedIntake-' + feedUnit"
            >
              {{ 'rvs-setting.feedIntake-option.' + feedUnit | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="wrapper--spacing-vertical">
        <h6 class="text--h6">{{ 'rvs-setting.waterIntake-option.label' | translate }}</h6>
        <div class="radio-group-wrapper">
          <mat-radio-group
            class="radio-group"
            color="primary"
            [ngModel]="(rvsSettings$ | async)?.waterUnit"
            (ngModelChange)="changeSystem($event, 'waterUnit')"
          >
            <mat-radio-button
              *ngFor="let waterUnit of waterUnits"
              [value]="waterUnit"
              [attr.data-test]="'settings__waterIntake-' + waterUnit"
            >
              {{ 'rvs-setting.waterIntake-option.' + waterUnit | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="wrapper--spacing-vertical">
        <h6 class="text--h6">{{ 'rvs-setting.weight-option.label' | translate }}</h6>
        <div class="radio-group-wrapper">
          <mat-radio-group
            class="radio-group"
            color="primary"
            [ngModel]="(rvsSettings$ | async)?.weightUnit"
            (ngModelChange)="changeSystem($event, 'weightUnit')"
          >
            <mat-radio-button
              *ngFor="let weightUnit of weightUnits"
              [value]="weightUnit"
              [attr.data-test]="'settings__weight-' + weightUnit"
            >
              {{ 'rvs-setting.weight-option.' + weightUnit | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="wrapper--spacing-vertical">
        <h6 class="text--h6">{{ 'rvs-setting.dayoffset.title' | translate }}</h6>
        <mat-form-field class="flex__child--auto spacing--margin-top">
          <mat-label>{{ 'rvs-setting.dayoffset.label' | translate }}</mat-label>
          <input
            matInput
            placeholder="0"
            step="0"
            data-test="settings__dayoffset"
            [ngModel]="dayOffset$ | async"
            (ngModelChange)="changeDayOffset($event)"
          />
        </mat-form-field>
      </div>
    </div>
  </agr-summary-card>
</div>
